export default "__VITE_ASSET__Cm7Bvp82__"